'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignupProductIntents;

var _signupProductIntents = require('../../core/constants/signupProductIntents');

var _signupProductIntents2 = _interopRequireDefault(_signupProductIntents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_SignupProductIntents = {}, _defineProperty(_SignupProductIntents, _signupProductIntents2.default.crm, 'CRM'), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.marketing, 'Marketing'), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.sales, 'Sales'), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.academy, 'Academy'), _defineProperty(_SignupProductIntents, _signupProductIntents2.default.service, 'Service'), _SignupProductIntents);
module.exports = exports['default'];